import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from '../pages.component';
import { StandbyDetailsComponent } from './standby-details/standby-details.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthGuard } from 'src/guards/auth.guard';





export const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'standby', pathMatch: 'full' },
      { path: 'standby/:eventID', component: StandbyDetailsComponent },
      { path: 'standby/:waitlistItemID', component: StandbyDetailsComponent },
      { path: 'standby', component: StandbyDetailsComponent }
    ]
  }
];





@NgModule({
  declarations: [StandbyDetailsComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class StandbyModule { }
